import { useBuyingListApi } from './useBuyingListApi';
import { useBuyingListGetters } from './useBuyingListGetters';
import { useBuyingListHelper } from './useBuyingListHelper';

import type { UseBuyingList } from './types';
export function useBuyingList(): UseBuyingList {
  return {
    ...useBuyingListApi(),
    ...useBuyingListGetters(),
    ...useBuyingListHelper(),
  };
}
